import {Component, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from '@angular/forms';
import {ModalDirective} from "ng2-bootstrap";
import {HttpService} from '../../../core/services/http.service';
import {environment} from "../../../../environments/environment";

export class WidgetModel {
  id: number;
  nazwa: string = '';
}

@Component({
  selector: 'widget-modal',
  templateUrl: './widget.modal.component.html',
  styleUrls: [ './widget.modal.component.scss' ]
})
export class WidgetModalComponent {
  public widget: WidgetModel = new WidgetModel();

  @ViewChild('widgetModal') 
  public widgetModal: ModalDirective;

  @Output()
  refreshList = new EventEmitter<boolean>();

  @Input()
  setModalMode;

  nazwa: FormControl = new FormControl("",Validators.required);
  
  widgetForm: FormGroup;

  errors: any;

  constructor( //private api: ApiService,
              private fb: FormBuilder,
              private http: HttpService
  ) {

    this.widgetForm = fb.group({
      'id': [null],
      'nazwa': this.nazwa      
    });

  }

  buildForm() {
    this.widgetForm.reset();
    this.widgetForm.patchValue(this.widget);
  }

  private backendUrl = environment.backendUrl;

  show(widget) {
    this.widget = widget ? widget : new WidgetModel();

    this.buildForm();

    this.widgetModal.show(); 
  }

  onSubmit(event) {
    if (!this.widgetForm.valid) {
      return;
    }

    this.widget = this.widgetForm.value;

    if(this.widget.id) {
      this.http.put(this.backendUrl+'api/template/'+this.widget.id, this.widgetForm.value )
           .subscribe(
                data => {
                  this.errors = [];
                  this.refreshList.emit();    
                  this.widgetModal.hide(); 
                  this.widgetForm.reset()
                },
                error => {
                  this.errors = error.json().errors;
                 }
           );
    }
    else {
      this.http.post(this.backendUrl+'api/template', this.widgetForm.value )
           .subscribe(
                data => {
                  this.errors = [];
                  this.refreshList.emit();    
                  this.widgetModal.hide(); 
                  this.widgetForm.reset()
                },
                error => {
                  this.errors = error.json().errors;
                 }
           );
    }

  } 

}





// WEBPACK FOOTER //
// /code/frontend/src/app/main/widgets/modals/widget.modal.component.ts